import React from "react";
const send = () => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_11:424)">
        <path
          d="M17.7748 10.5448H4.81116"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.7746 10.5449L1.86471 18.2052L4.81099 10.5449L1.86471 2.88456L17.7746 10.5449Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_11:424">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 0.544922)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default send;
